import { AreaChart } from '@tremor/react'
import type { ReportVolumeDataPoint } from './types'

interface Props {
  data: ReportVolumeDataPoint[]
}

export function ReportVolumeTimeline({ data }: Props) {
  if (data.length === 0) {
    return (
      <div className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-5">
        <h3 className="font-medium text-stone-900 dark:text-stone-100">Report & Item Volume</h3>
        <div className="h-72 flex items-center justify-center text-sm text-stone-500 dark:text-stone-400">
          No data available for the selected period
        </div>
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-5">
      <h3 className="font-medium text-stone-900 dark:text-stone-100">Report & Item Volume</h3>
      <p className="text-xs text-stone-500 dark:text-stone-400 mt-1">
        Reports generated and items processed over time
      </p>

      <div className="mt-4 [&_.tremor-Legend-root]:hidden [&_text]:text-[10px] [&_text]:fill-stone-400">
        <AreaChart
          className="h-64"
          data={data}
          index="date"
          categories={['reportCount', 'itemCount']}
          colors={['teal', 'blue']}
          yAxisWidth={32}
          showAnimation
          showLegend={false}
          valueFormatter={(value) => value.toLocaleString()}
        />
      </div>

      <div className="mt-3 flex items-center gap-4 text-[10px] text-stone-500 dark:text-stone-400">
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-teal-500" />
          <span>Reports</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-blue-500" />
          <span>Items</span>
        </div>
      </div>
    </div>
  )
}
